module.exports = __webpack_public_path__ + "static/media/FTSI-Logo.e22769f4.png";